export interface EarlyDeliverySizeInfo {
  size: string;
  displaySize: string;
  expectedDeliveryDate: string;
}

export interface EarlyDeliveryItem {
  id: string;
  customizationId: number;
  metalPurity: string;
  metalType: string;
  metalColor: string;
  diamondClarity: string | null;
  diamondColor: string | null;
  solitaireCarat: string | null;
  solitaireClarity: string | null;
  solitaireColor: string | null;
  size: EarlyDeliverySizeInfo;
}

export const EARLY_DELIVERY_PERIOD_DAYS = 3;
